import { useFormik } from "formik";
import { useAppSelector } from "store";
import * as Yup from "yup";

const useDetails = () => {
  const userDetails = useAppSelector(
    (state) => state.appLayout.userDetails as any
  );

  const formik = useFormik({
    initialValues: {
      executionDate:
        userDetails?.vendorAgreement?.executionDate ??
        new Date().toLocaleDateString("en-US", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }),
      executionStatus:userDetails?.vendorAgreement?.executionStatus ?? "PENDING",
      legalName: userDetails?.organisationDetails?.legal_name || userDetails?.organisationDetails?.name_of_enterprise || "",
      address:
        userDetails?.organisationDetails?.primary_business_address
          ?.registered_address || userDetails?.organisationDetails?.formatedAddress || "",
      readVendorAgreement:
        userDetails?.vendorAgreement?.readVendorAgreement ?? false,
      authorisation: {
        name: userDetails?.vendorAgreement?.authorisation?.name ?? "",
        designation:
          userDetails?.vendorAgreement?.authorisation?.designation ?? "",
        Place: userDetails?.vendorAgreement?.authorisation?.Place ?? "",
      },
    },
    validationSchema: Yup.object({
      executionDate: Yup.string().required("Execution Date is required"),
      executionStatus: Yup.string().required("Execution Status is required"),
      readVendorAgreement: Yup.boolean()
        .oneOf([true], "You Must Accept Agreement")
        .required("You must accept the agreement"),
      legalName: Yup.string().required("Legal Name is required"),
      address: Yup.string().required("Address is required"),
      authorisation: Yup.object().shape({
        name: Yup.string().required("Name is required"),
        designation: Yup.string().required("Designation is required"),
        Place: Yup.string().required("Place is required"),
      }),
    }),
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log("val",values);
    },
  });
  return { formik, userDetails };
};

export default useDetails;
